module.exports = __webpack_public_path__ + "static/media/Statistics.6f849155.svg";